import React, { ChangeEvent, ReactElement, useRef, useState } from "react";
import { Button, Col, Form as BSForm, Row } from "react-bootstrap";
import { Tag } from "./Tag";
import { TagService } from "./TagService";

interface IParams {
	onCreate: (tag: Tag) => void;
}

export const TagCreateForm = (props: IParams): ReactElement => {
	const [name, setName] = useState("");
	const [submitting, setSubmitting] = useState(false);
	const nameRef = useRef<HTMLInputElement>(null);
	const tagService = new TagService();

	const handleSubmit = async () => {
		if (!name.trim()) {
			nameRef.current?.focus();
			return;
		}
		setSubmitting(true);
		const newTag = await tagService.create(name.trim());
		setSubmitting(false);
		setName("");
		props.onCreate(newTag);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			handleSubmit();
		}
	};

	return (
		<>
			<h5 className="mb-3" style={{ fontWeight: 600 }}>
				<i className="fa fa-plus-circle" style={{ marginRight: 8, opacity: 0.6 }} />
				New Tag
			</h5>
			<BSForm>
				<Row>
					<Col md={8}>
						<BSForm.Group>
							<BSForm.Label>Tag Name</BSForm.Label>
							<BSForm.Control
								ref={nameRef}
								type="text"
								placeholder="e.g. Hot Lead, VIP, Newsletter"
								value={name}
								onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
								onKeyDown={handleKeyDown}
							/>
						</BSForm.Group>
					</Col>
					<Col md={4} className="d-flex align-items-end">
						<BSForm.Group className="w-100">
							<Button
								onClick={handleSubmit}
								disabled={submitting || !name.trim()}
								className="w-100"
							>
								{submitting ? (
									<>
										<i className="fa fa-spinner fa-spin" /> Creating...
									</>
								) : (
									"Create Tag"
								)}
							</Button>
						</BSForm.Group>
					</Col>
				</Row>
			</BSForm>
		</>
	);
};
